import { Box } from '@mui/material';
import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Title from '/@/components/title';
import styles from './styles.module.css';

@autobind
export default class Section extends Component {
    static propTypes = {
        title: PropTypes.string,
        icon: PropTypes.string,
        brand: PropTypes.object,
        children: PropTypes.node.isRequired,
    };

    render() {
        const { icon, title, brand, children } = this.props;

        return (
            <Box
                sx={{
                    '&:not(:last-child)': {
                        paddingBottom: 3,
                        borderBottom: (t) => `2px solid ${t.palette.primary.main}`,
                    },
                    pt: 3,
                    '&:first-child': {
                        mt: 2,
                    },
                }}
            >
                {title && (
                    <div className={styles.header}>
                        {icon && brand && <Icon type={icon} size='md' theme={brand.theme} container='circle' />}
                        <Title size='xl'>{title}</Title>
                    </div>
                )}
                {children}
            </Box>
        );
    }
}
